module.exports = __webpack_public_path__ + "img/news.9f56759e.jpg";